import { ApiHttpService } from '../ApiHttpService';
import { Phone } from '../../models/Phone';
import { PhoneSerializer } from '../serializers/PhoneSerializer';
import { ParamsHelper } from '../../helpers/ParamsHelper';

const BASIC_PHONE_ROUTEGET = 'usuario/gettelefono?tipo=0';
const BASIC_PHONE_ROUTE = 'usuario/telefono';

class PhoneController {
  static async addPhone(number) {
    const authenticated = true;
    const params = { numero: number };
    const response = await ApiHttpService.post(`${BASIC_PHONE_ROUTE}${ParamsHelper.createQueryParams(params)}`, {}, authenticated);
    let phone = response.data;
    phone = PhoneSerializer.deSerialize(phone);
    return new Phone(phone);
  }

  static async getPhones() {
    const authenticated = true;
    const response = await ApiHttpService.get(BASIC_PHONE_ROUTEGET, {}, authenticated);
    let phones = response.data;
    phones = phones.map(phone => PhoneSerializer.deSerialize(phone));
    return phones.map(phone => new Phone(phone));
  }

  static async deletePhone(number) {
    const authenticated = true;
    const params = { numero: number };
    await ApiHttpService.delete(`${BASIC_PHONE_ROUTE}${ParamsHelper.createQueryParams(params)}`, {}, authenticated);
  }
}

export { PhoneController };



// WEBPACK FOOTER //
// ./src/networking/controllers/PhoneController.js